import identity from 'transmute/identity';
import { CLOSING_THREAD } from '../constants/asyncStatuses';
import { requestStateUpdate } from 'conversations-async-data/async-data/operators/requestStateUpdate';

/**
 * @description a custom status setter that sets the status
 * of a thread list membmer details object to 'CLOSING_THREAD'
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
 */
export const setClosingThreadStatusWithOperator = (operator = identity) =>
// @ts-expect-error AsyncData does not allow this status
requestStateUpdate(CLOSING_THREAD, operator);